export function clearMask (input: string | null, mask: string | null, charholder: string) {
    if (mask && input) {
        new Set(Array.from(mask.split('#').join(charholder))).add(' ').forEach((maskDelimiter) => {
            input = (input as string).split(maskDelimiter).join('');
        });
    }

    return input;
}

export function applyMask (input: string | null, mask: string | null, charholder: string) {
    if (mask) {
        if (!input) {
            return '';
        }

        let fittedInput = clearMask(input, null, charholder) || '';

        let insertChar = (str: string, char: string, index: number) => {
            if (str.length <= index) {
                return str;
            }
            return Array.from(str.slice(0, index)).concat([char]).join('') + str.slice(index);
        };

        let eMask = Array.from(mask).map((delimiter, index) => {
            return {
                delimiter,
                index,
            };
        });

        eMask.forEach(maskItem => {
            if (maskItem.delimiter !== '#') {
                fittedInput = insertChar(fittedInput, maskItem.delimiter, maskItem.index);
            }
        });

        return (fittedInput + mask.slice(fittedInput.length).replace(/#/g, charholder)).slice(0, mask.length);
    }

    return input;
}

export function trimMask (input: string | null, mask: string | null, charholder: string) {
    if (mask && input) {
        let maskReversed = Array.from(mask).reverse();
        let end = Array.from(input).reverse().findIndex((char, index) => {
            return char !== charholder && maskReversed[index] === '#';
        });

        return input.slice(0, end >= 0 ? input.length - end : input.length);
    }

    return input;
}
